import { IconSvg, IconSvgProps } from "./icon"

export default function AddTrip(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M7.62 7.103V5.81A1.81 1.81 0 0 1 9.432 4h4.138a1.81 1.81 0 0 1 1.81 1.81v1.293m-7.758 0H5.81c-1 0-1.811.811-1.811 1.81v8.277c0 1 .81 1.81 1.81 1.81h5.69M7.62 7.103h7.76m0 0h1.81c1 0 1.81.811 1.81 1.81v2.87" />
      <path d="M18.165 15.383c.035 0 .065.029.065.065v2.435h2.435a.065.065 0 0 1 0 .13H18.23v2.435c0 .037-.03.066-.065.066a.066.066 0 0 1-.065-.066v-2.434h-2.435a.066.066 0 0 1-.065-.066c0-.036.03-.065.065-.065H18.1v-2.435c0-.036.03-.065.065-.065Z" />
    </IconSvg>
  )
}
